// ===== くつひもメーター：スマホ画面の定規（Issue #19） =====
// 設計: plans/2026-09_くつひもメーター_スマホ定規.md（meta リポ）
// - 公開 API は window.LaceRuler の open / close / isOpen だけ
// - メーター本体（shoelace-calculator.js）とは「開く」と「値を入れる」の 2 点でしかつながらない
// - このファイルか lace-ruler.css が読めない時は、起動ボタン（[data-lace-ruler-show]）を hidden のまま残す
(function () {
  'use strict';

  var CAL_KEY = 'mondLaceRuler.cal.v1';     // 画面合わせの結果（縦向き・横向きで別々に保存）
  var PREF_KEY = 'mondLaceRuler.pref.v1';   // 前回の測り方・案内を見たか
  var DEFAULT_PX_PER_MM = 6.4;              // 未調整時の初期値（一般的なスマホの目安）
  var A_MM = 6;                             // A（0 の線）は上端から 6mm に固定（測れる長さを広げるため最小限に）
  var HOLD_MS = 1000;                       // ロック解除の長押しの長さ（CSS の .lr-unlock.is-holding の transition と揃える）
  var BD_RESERVE = 56;                      // 継ぎ足し中は、定規の下端に重ねる内訳（約 34px）とつまみの下半分（17px）が重ならない所までしか線を下げられなくする（px）
  var TOL = 0.0025;                         // 校正の失効判定の許容差（0.25%。根拠はプラン参照）
  var REF = {
    card: { mm: 85.6, shortMm: 53.98 },     // クレジット・キャッシュカード（ISO/IEC 7810 ID-1）の長辺・短辺
    coin: { mm: 20.0 }                      // 1円玉の直径
  };
  var CAL_TEXT = {
    'card-v': 'カードを縦向きにして枠の上の角に合わせて置き、下のふちが枠とぴったり重なるまで − ＋ で調整してください。',
    'card-h': 'カードを横向きにして画面に置き、上下のふちを 2 本の線にぴったり合わせてください（左右は画面からはみ出して大丈夫です）。',
    'card-w': 'カードを横向きにして画面の下の方に置き、左右のふちを 2 本の線にぴったり合わせてください（下は画面からはみ出して大丈夫です）。',
    'none': 'この向きの画面ではカードが収まりません。スマホを縦向きにするか、1円玉を選んでください。',
    coin: '1円玉を円の上に置き、ふちがぴったり重なるまで − ＋ で調整してください。'
  };

  var root = document.getElementById('lace-ruler');
  if (!root) return;

  // ---------- 保存（使えない端末では何もしない） ----------
  function readJSON(key) {
    try {
      var raw = window.localStorage.getItem(key);
      if (!raw) return null;
      var v = JSON.parse(raw);
      return (v && typeof v === 'object') ? v : null;
    } catch (e) { return null; }
  }
  function writeJSON(key, value) {
    try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* 容量エラー・無効化時は保存しない */ }
  }

  // ---------- GA4 ----------
  function track(name, params) {
    try {
      if (typeof window.gtag !== 'function') return;
      var p = params || {};
      p.surface = state.surface;
      window.gtag('event', name, p);
    } catch (e) { /* 計測の失敗で定規を止めない */ }
  }

  // ---------- 端末の状態と校正の有効性 ----------
  function orientationKey() {
    // 表示領域の縦横で判断する（screen.orientation は端末やブラウザによって表示と食い違うことがある）
    try {
      if (window.matchMedia) return window.matchMedia('(orientation: portrait)').matches ? 'p' : 'l';
    } catch (e) {}
    return window.innerHeight >= window.innerWidth ? 'p' : 'l';
  }
  function metrics() {
    var o = orientationKey();
    var sw = screen.width, sh = screen.height;
    var shortSide = Math.min(sw, sh), longSide = Math.max(sw, sh);
    return {
      orient: o,
      dpr: window.devicePixelRatio || 1,
      short: shortSide,
      // 向きに合わせた「画面の幅」に対するページの幅の比。ページ拡大（iOS Safari の表示倍率など）で変わる
      ratio: window.innerWidth / (o === 'p' ? shortSide : longSide)
    };
  }
  function viewportScaleOk() {
    var vv = window.visualViewport;
    return !vv || Math.abs(vv.scale - 1) < TOL;
  }
  function preventDefault(e) { e.preventDefault(); }
  function isFiniteNum(v) { return typeof v === 'number' && isFinite(v); }
  function loadCal() {
    var all = readJSON(CAL_KEY);
    var c = all && all[metrics().orient];
    // 壊れた保存値・範囲外の値は無かったことにする（合わせ直しになる）
    if (!c || typeof c !== 'object') return null;
    if (!isFiniteNum(c.pxPerMm) || c.pxPerMm < 4.5 || c.pxPerMm > 8.5) return null;
    if (!isFiniteNum(c.dpr) || !isFiniteNum(c.short) || !isFiniteNum(c.ratio) || c.ratio <= 0) return null;
    if (c.ref !== 'card' && c.ref !== 'coin') return null;
    return c;
  }
  function isCalibrationValid(c) {
    if (!c) return false;
    var m = metrics();
    if (c.dpr !== m.dpr) return false;
    if (c.short !== m.short) return false;
    if (!(c.ratio > 0) || Math.abs(m.ratio - c.ratio) / c.ratio >= TOL) return false;
    if (!viewportScaleOk()) return false;
    return true;
  }

  // ---------- 状態 ----------
  var pref = readJSON(PREF_KEY) || {};
  if (pref.method !== 'lace') pref.method = 'direct';
  if (!pref.seen || typeof pref.seen !== 'object') pref.seen = {};

  var state = {
    open: false,
    view: null,
    input: null,
    opener: null,
    label: '',
    step: null,
    surface: 'page',
    coarse: false,
    touchPc: false,
    pxPerMm: DEFAULT_PX_PER_MM,
    calRef: 'card',
    calMode: 'card-v',    // card-v: カード縦（長辺を縦に）/ card-w: 横長の画面でカード横（長辺を横に）/ card-h: カード横（短辺を縦に）/ none: 収まらない / coin
    measureOrient: null,  // 測り始めた時の画面の向き
    calPpm: DEFAULT_PX_PER_MM,
    bMm: 30,              // B は A からの距離（mm・整数＝0.1cm 刻み）
    chain: [],            // 継ぎ足した区間（mm・整数）
    rulerH: 0,
    abort: null,
    observer: null,
    inerted: [],
    prevOverflow: null,
    drag: null,           // { id, offset }
    raf: 0,
    sessionCals: {},      // localStorage が使えない時のための、ページ内だけの控え
    pendingInit: false,
    phone: false,         // スマホか（open の時に 1 回だけ判定。横向きでは覆いを出して止める）
    pendingStart: false,  // スマホを横向きで開いた時、縦になるまで画面合わせ・定規を始めない
    locked: false,        // 誤タップ防止のロック
    hold: null,           // ロック解除の長押し中 { kind: 'p'|'k', id, timer }   // 次に定規を描いた時に、入力欄の値から線の位置を決め直す
    lastByInput: {}       // 入力欄ごとの前回の測り方（継ぎ足しを含む）。ページを開いている間だけ
  };

  var $ = function (sel) { return root.querySelector(sel); };
  var calIntro = $('[data-lr-cal-intro]');
  var calAlign = $('[data-lr-cal-align]');
  var views = {
    cal: $('[data-lr-view="cal"]'),
    ruler: $('[data-lr-view="ruler"]'),
    qr: $('[data-lr-view="qr"]')
  };
  var el = {
    alert: $('[data-lr-alert]'),
    rotate: $('[data-lr-rotate]'),
    rotateKept: $('[data-lr-rotate-kept]'),
    lockBtn: $('[data-lr-action="lock"]'),
    lockChip: $('[data-lr-lock-chip]'),
    unlock: $('[data-lr-unlock]'),
    unlockSub: $('[data-lr-unlock-sub]'),
    stepNo: $('[data-lr-stepno]'),
    calText: $('[data-lr-cal-text]'),
    calControls: $('.lr-cal-controls'),
    stage: $('[data-lr-stage]'),
    calRange: $('[data-lr-cal-range]'),
    calWarn: $('[data-lr-cal-warn]'),
    calSave: $('[data-lr-action="cal-save"]'),
    ruler: $('[data-lr-ruler]'),
    canvas: $('[data-lr-canvas]'),
    band: $('[data-lr-band]'),
    a: $('[data-lr-a]'),
    b: $('[data-lr-b]'),
    value: $('[data-lr-value]'),
    breakdown: $('[data-lr-breakdown]'),
    undo: $('[data-lr-action="undo"]'),
    qrLink: $('[data-lr-action="show-qr"]'),
    useHere: $('[data-lr-action="use-here"]')
  };
  var labels = root.querySelectorAll('[data-lr-label]');
  var help = $('[data-lr-help]');   // 測り方の案内（タブで「直接当てる／紐で写し取る」の説明を切り替えるだけ。定規の動きは変わらない）
  var helpBtn = $('[data-lr-action="help"]');

  // ---------- 表示の切替 ----------
  function showView(name) {
    state.view = name;
    Object.keys(views).forEach(function (k) { views[k].hidden = (k !== name); });
    if (name !== 'ruler') { help.hidden = true; setLocked(false); }   // 定規から別の画面に移ったらロックも外す
  }

  // ---------- 誤タップ防止のロック ----------
  // ロック中：ボタンは「長押しで解除」以外すべて止める（委譲クリックも無視）。線はロックに関係なく、つまみを直接つかんだ時だけ動く
  var rulerBack = views.ruler.querySelector('[data-lr-action="close"]');
  function setLocked(on) {
    cancelHold();
    state.locked = !!on;
    root.classList.toggle('is-locked', state.locked);
    el.unlock.hidden = !state.locked;
    el.lockChip.hidden = !state.locked;
    rulerBack.disabled = state.locked;
    helpBtn.disabled = state.locked;
    el.lockBtn.setAttribute('aria-pressed', String(state.locked));
  }
  function lockRuler() {
    if (state.view !== 'ruler' || state.locked || !help.hidden) return;   // 案内が開いている間はロックしない（解除ボタンが案内の裏に隠れるため）
    endDrag();
    setLocked(true);
    track('meter_ruler_lock', { step: state.step, method: pref.method });
    focusEl(el.unlock);
  }
  function startHold(kind, id) {
    if (!state.locked || state.hold || rotateBlocked()) return;
    var hold = { kind: kind, id: id, timer: 0 };
    state.hold = hold;
    el.unlock.classList.add('is-holding');
    el.unlockSub.textContent = 'そのまま押し続ける';
    hold.timer = setTimeout(function () {
      if (state.hold !== hold || !state.open || !state.locked) return;   // 別の押下・閉じた後・解除済みなら何もしない
      if (rotateBlocked()) { cancelHold(); return; }   // 押している間に横向きになった：ロックは保つ
      setLocked(false);
      focusEl(el.lockBtn);
    }, HOLD_MS);
  }
  function cancelHold() {
    var h = state.hold;
    state.hold = null;
    if (h) clearTimeout(h.timer);
    el.unlock.classList.remove('is-holding');
    el.unlockSub.textContent = '1 秒押し続ける';
  }
  function endHold(kind, id) {
    if (state.hold && state.hold.kind === kind && state.hold.id === id) cancelHold();
  }
  function onUnlockPointerDown(e) {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    e.preventDefault();   // 長押しでの文字選択・フォーカス移動のずれを防ぐ
    startHold('p', e.pointerId);
  }
  function onUnlockPointerMove(e) {
    if (!state.hold || state.hold.kind !== 'p' || state.hold.id !== e.pointerId) return;
    var r = el.unlock.getBoundingClientRect();   // タッチは暗黙に捕捉されて pointerleave が来ないので、座標で外れを見る
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) cancelHold();
  }
  function onUnlockPointerEnd(e) { endHold('p', e.pointerId); }
  function onUnlockKeyDown(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault();
    if (e.repeat) return;   // キーのリピートは無視（押し始めの 1 回だけ数える）
    startHold('k', e.key);
  }
  function onUnlockKeyUp(e) { endHold('k', e.key); }
  function onHidden() { if (document.visibilityState === 'hidden') cancelHold(); }

  // ---------- スマホで横向きになった時の覆い ----------
  function rotateShown() { return !el.rotate.hidden; }
  // 回転を検知してから覆いが出るまで（次の描画フレーム）の間も、操作を受け付けない
  function rotateBlocked() {
    return rotateShown() || (state.phone && orientationKey() === 'l' &&
      (state.pendingStart || state.view === 'cal' || state.view === 'ruler'));
  }
  function showRotate() {
    endDrag();
    cancelHold();
    var total = state.view === 'ruler' ? sum() + curB() : 0;
    el.rotateKept.hidden = !(total > 0);
    if (total > 0) el.rotateKept.textContent = '測った長さ ' + (total / 10).toFixed(1) + ' cm はそのまま残っています';
    if (rotateShown()) return;
    Object.keys(views).forEach(function (k) { views[k].inert = true; });   // 下の画面は操作もフォーカスもできなくする
    el.rotate.hidden = false;
    focusEl(el.rotate);
  }
  function hideRotate() {
    if (!rotateShown()) return false;
    el.rotate.hidden = true;
    Object.keys(views).forEach(function (k) { views[k].inert = false; });
    return true;
  }
  var alertTimer = 0;
  // 継ぎ足し直後の案内（古い区間の点線を指す）だけを消す。画面の高さの警告などは残す
  function hideChainAlert() {
    if (!el.alert.hidden && el.alert.textContent.indexOf('継ぎ足し位置') !== -1) el.alert.hidden = true;
  }
  function showAlert(text) {
    el.alert.textContent = text;
    el.alert.hidden = false;
    clearTimeout(alertTimer);
    alertTimer = setTimeout(function () { el.alert.hidden = true; }, 3500);
  }

  // ---------- 画面を合わせる（説明 → 合わせる） ----------
  function renderRefChoice() {
    root.querySelectorAll('[data-lr-ref]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-lr-ref') === state.calRef));
    });
  }
  function decideCalMode() {
    if (state.calRef === 'coin') { state.calMode = 'coin'; return; }
    // 合わせる枠が画面に収まる置き方を、正確な順（長辺を使う方が正確）に選ぶ
    var roomH = el.stage.clientHeight - 8;
    var roomW = el.stage.clientWidth - 16;
    var p = state.calPpm;
    if (roomH >= REF.card.mm * p * 1.06) state.calMode = 'card-v';          // 縦長の画面：カード縦
    else if (roomW >= REF.card.mm * p * 1.06) state.calMode = 'card-w';     // 横長の画面：カード横・長辺を横に
    else if (roomH >= REF.card.shortMm * p * 1.06) state.calMode = 'card-h'; // 小さな縦長の画面：カード横・短辺を縦に
    else state.calMode = 'none';
  }
  function renderCal() {
    if (calAlign.hidden) return;
    decideCalMode();   // 大きさ・画面の高さ・向きが変わるたびに、カード縦で収まるかを判定し直す
    el.calText.textContent = CAL_TEXT[state.calMode];
    var p = state.calPpm;
    var frame = document.createElement('div');
    if (state.calMode === 'card-v') {
      frame.className = 'lr-frame-card';
      frame.style.width = (REF.card.shortMm * p) + 'px';
      frame.style.height = (REF.card.mm * p) + 'px';
      frame.style.borderRadius = (3.18 * p) + 'px';
      frame.textContent = 'カードをここに';
    } else if (state.calMode === 'card-h') {
      frame.className = 'lr-frame-card-h';
      frame.style.height = (REF.card.shortMm * p) + 'px';
      frame.textContent = 'カードを横向きに置く';
    } else if (state.calMode === 'card-w') {
      frame.className = 'lr-frame-card-w';
      frame.style.width = (REF.card.mm * p) + 'px';
      frame.textContent = 'カードを横向きに置く';
    } else if (state.calMode === 'none') {
      frame.className = 'lr-frame-none';
    } else {
      frame.className = 'lr-frame-coin';
      frame.style.width = frame.style.height = (REF.coin.mm * p) + 'px';
    }
    el.stage.replaceChildren(frame);
    // 枠を画面全体の真ん中に寄せる（上の説明と下の操作欄の高さの差の半分だけずらす。枠がはみ出す分はずらさない）
    var lim = Math.max(0, (el.stage.clientHeight - frame.offsetHeight) / 2 - 4);
    var shift = Math.max(-lim, Math.min(lim, (el.calControls.offsetHeight - el.calText.offsetHeight) / 2));
    frame.style.transform = shift ? 'translateY(' + shift + 'px)' : '';
    el.calRange.value = String(p);
    var ok = viewportScaleOk();
    el.calWarn.hidden = ok;
    el.calSave.disabled = !ok || state.calMode === 'none';   // 枠が収まっていない時は決定できない
  }
  function showCal() {
    var c = loadCal() || state.sessionCals[metrics().orient] || null;
    state.calPpm = Math.min(8.5, Math.max(4.5, c ? c.pxPerMm : (state.pxPerMm || DEFAULT_PX_PER_MM)));
    if (c && (c.ref === 'card' || c.ref === 'coin')) state.calRef = c.ref;
    showView('cal');
    calIntro.hidden = false;
    calAlign.hidden = true;
    renderRefChoice();
    focusEl($('[data-lr-action="cal-start"]'));
  }
  function startAlign() {
    calIntro.hidden = true;
    calAlign.hidden = false;
    // 説明文の行数で合わせる場所の高さが変わるので、先に文を入れてから測る
    el.calText.textContent = CAL_TEXT[state.calRef === 'coin' ? 'coin' : 'card-v'];
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        renderCal();
        focusEl($('[data-lr-action="cal-minus"]'));
      });
    });
  }
  function saveCal() {
    if (!viewportScaleOk() || state.calMode === 'none') { renderCal(); return; }
    var m = metrics();
    var all = readJSON(CAL_KEY) || {};
    all[m.orient] = {
      pxPerMm: state.calPpm, ref: state.calRef, mode: state.calMode,
      dpr: m.dpr, short: m.short, ratio: m.ratio, savedAt: Date.now()
    };
    writeJSON(CAL_KEY, all);
    state.pxPerMm = state.calPpm;
    state.sessionCals[m.orient] = all[m.orient];   // 保存できない端末でも、ページを開いている間は使う
    track('meter_ruler_calibrate', { ref: state.calRef, mode: state.calMode });
    showRuler(true);
  }

  // ---------- 定規 ----------
  function currentCal() {
    var o = metrics().orient;
    var list = [state.sessionCals[o], loadCal()];
    for (var i = 0; i < list.length; i++) if (isCalibrationValid(list[i])) return list[i];
    return null;
  }
  function startMeasure() {
    var c = currentCal();
    if (!c) { showCal(); return; }
    state.pxPerMm = c.pxPerMm;
    showRuler(false);
  }
  function showRuler(fromCal) {
    state.measureOrient = metrics().orient;
    showView('ruler');
    el.qrLink.hidden = state.coarse;
    requestAnimationFrame(function () {
      if (rotateBlocked()) { showRotate(); return; }   // 描く前に横向きになった：縦に戻った時に onViewportChange が続きを行う
      layoutRuler();
      if (state.pendingInit) { applyInitial(); layoutRuler(); }
      if (!pref.seen[pref.method]) openHelp(pref.method);
      else focusEl(helpBtn);
    });
  }
  // 案内のタブを切り替える。最後に見た方を次に開いた時も最初に出す（GA4 の method もこの値）
  function showMethod(method) {
    pref.method = method === 'lace' ? 'lace' : 'direct';
    pref.seen[pref.method] = true;
    writeJSON(PREF_KEY, pref);
    root.querySelectorAll('[data-lr-method]').forEach(function (b) {
      b.setAttribute('aria-selected', String(b.getAttribute('data-lr-method') === pref.method));
      b.tabIndex = b.getAttribute('data-lr-method') === pref.method ? 0 : -1;
    });
    root.querySelectorAll('[data-lr-help-panel]').forEach(function (n) {
      n.hidden = n.getAttribute('data-lr-help-panel') !== pref.method;
    });
  }
  function openHelp(method) {
    showMethod(method);
    help.hidden = false;
    help.querySelector('.lr-sheet-in').scrollTop = 0;
    focusEl($('[data-lr-method="' + pref.method + '"]'));
  }
  function closeHelp() {
    help.hidden = true;
    focusEl(helpBtn);
  }

  function sum() { return state.chain.reduce(function (a, b) { return a + b; }, 0); }
  function yA() { return A_MM * state.pxPerMm; }
  // 画面に出ている線の位置（mm）。state.bMm は動かした値のまま持ち、画面の高さが一時的に縮んでも書き換えない
  function curB() { return Math.max(0, Math.min(maxBmm(), Math.round(state.bMm))); }
  function maxBmm() {
    var room = state.rulerH - yA() - (state.chain.length ? BD_RESERVE : 0);
    return Math.max(0, Math.floor(room / state.pxPerMm));
  }

  // 目盛りの文字（DS v2: 数字は Jost、和文は Noto Sans JP）。フォントの読み込みが遅れたら読み込み後に描き直す
  var RULER_FONT_NUM = '300 12px Jost, "Noto Sans JP", sans-serif';
  var RULER_FONT_LABEL = '500 11px "Noto Sans JP", "Hiragino Sans", sans-serif';
  var RULER_FONT_LABEL_L = '500 12px "Noto Sans JP", "Hiragino Sans", sans-serif';
  function drawTicks() {
    var r = el.ruler.getBoundingClientRect();
    var W = r.width, H = r.height;
    state.rulerH = H;
    var dpr = window.devicePixelRatio || 1;
    el.canvas.width = Math.round(W * dpr);
    el.canvas.height = Math.round(H * dpr);
    var c = el.canvas.getContext('2d');
    c.setTransform(dpr, 0, 0, dpr, 0, 0);
    c.clearRect(0, 0, W, H);
    var p = state.pxPerMm, off = sum(), y0 = yA();
    c.fillStyle = 'rgba(38,36,32,0.06)';
    c.fillRect(0, 0, W, y0);                               // A より上は使わない所
    c.textBaseline = 'middle';
    c.font = RULER_FONT_NUM;
    for (var m = off; ; m++) {                              // 目盛りは継ぎ足した長さの続きから
      var y = y0 + (m - off) * p;
      if (y > H) break;
      var isCm = m % 10 === 0, isHalf = m % 5 === 0;
      var len = isCm ? 22 : isHalf ? 14 : 8;
      c.strokeStyle = isCm ? '#262420' : '#96917F';
      c.lineWidth = isCm ? 1.2 : 0.8;
      c.beginPath();
      c.moveTo(0, y); c.lineTo(len, y);
      c.moveTo(W, y); c.lineTo(W - len, y);
      c.stroke();
      if (isCm && y - y0 > 14) {
        c.fillStyle = '#262420';
        c.textAlign = 'left'; c.fillText(String(m / 10), 26, y);
        c.textAlign = 'right'; c.fillText(String(m / 10), W - 26, y);
      }
    }
    if (state.chain.length) {
      // 継ぎ足した直前の区間の端（つまんだ所）が今どこにあるかを薄い点線で残す。紐をずらしてこの線を 0 の線に合わせる目安
      // 点線は本当の位置にだけ描く（画面が縮んで位置が画面の外に出た時は、線は描かず「画面の下」と知らせる）
      var gyTrue = y0 + state.chain[state.chain.length - 1] * p;
      var gl = '区間 ' + state.chain.length + ' 継ぎ足し位置';
      c.font = RULER_FONT_LABEL;
      var gw, gx, gt;
      if (gyTrue <= H) {
        var gy = Math.min(gyTrue, H - 1);        // 下端ちょうどでも線が見えるように
        c.save();
        c.strokeStyle = 'rgba(110,77,53,0.55)';
        c.lineWidth = 2;
        c.setLineDash([7, 5]);
        c.beginPath(); c.moveTo(0, gy); c.lineTo(W, gy); c.stroke();
        c.restore();
        gt = gy - 20;                            // 札は線のすぐ上
        if (gt < y0 + 2) gt = gy + 3;            // 0 の線に近い（短い区間）時は線のすぐ下
        if (gt > H - 58) gt = H - 58;            // 下端の近くでは、左下の内訳より上に置く
      } else {
        gl = '▼ ' + gl + '（画面の下）';
        gt = H - 58;
      }
      gw = c.measureText(gl).width + 12;
      gx = W - 46 - gw;                          // 右側の cm の数字（W-26 から左へ約 12px）に重ならない位置
      c.fillStyle = 'rgba(251,250,247,0.92)';
      c.fillRect(gx, gt, gw, 17);
      c.fillStyle = 'rgba(110,77,53,0.9)';
      c.textAlign = 'left';
      c.textBaseline = 'middle';
      c.fillText(gl, gx + 6, gt + 9);
    }
    c.fillStyle = '#6E4D35';
    c.textAlign = 'left';
    c.textBaseline = 'bottom';
    c.font = RULER_FONT_LABEL_L;
    c.fillText(state.chain.length
      ? '区間 ' + (state.chain.length + 1) + '：' + (off / 10).toFixed(1) + ' cm から'
      : '0（ここに端を合わせる）', 26, y0 - 4);
  }
  function place() {
    var b = curB();
    var y0 = yA();
    el.a.style.top = y0 + 'px';
    el.b.style.top = (y0 + b * state.pxPerMm) + 'px';
    el.band.style.top = y0 + 'px';
    el.band.style.height = (b * state.pxPerMm) + 'px';
    var total = sum() + b;
    var unit = document.createElement('small');
    unit.textContent = 'cm';
    el.value.replaceChildren(document.createTextNode((total / 10).toFixed(1)), unit);
    el.b.setAttribute('aria-valuenow', String(total / 10));
    el.b.setAttribute('aria-valuetext', (total / 10).toFixed(1) + 'cm');
    el.b.setAttribute('aria-valuemax', String((sum() + maxBmm()) / 10));
    el.breakdown.hidden = !state.chain.length;
    if (state.chain.length) {
      var tag = document.createElement('span');
      tag.className = 'lr-tag';
      tag.textContent = '区間 ' + (state.chain.length + 1);
      var txt = document.createElement('span');
      // 1 行に収める（線の下端の予約 BD_RESERVE は 1 行ぶん）。区間が多い時は前の区間をまとめる
      var parts = state.chain.length <= 2
        ? state.chain.concat([b]).map(function (x) { return (x / 10).toFixed(1); }).join(' + ')
        : 'ここまで ' + (sum() / 10).toFixed(1) + ' + ' + (b / 10).toFixed(1);
      txt.textContent = parts + ' = ' + (total / 10).toFixed(1) + ' cm';
      el.breakdown.replaceChildren(tag, txt);
    }
    el.undo.hidden = !state.chain.length;
  }
  function layoutRuler() {
    if (state.view !== 'ruler') return;
    drawTicks();
    place();
  }
  function resetMeasure() {
    state.chain = [];
    state.bMm = 30;
  }
  // 開いた時の線の位置：前回この欄をスマホで測って値を入れたままなら、その時の測り方（継ぎ足しを含む）に戻す。
  // そうでなければ入力欄の値（各ステップの初期値や手入力の値）に置く。1 画面に収まらない値は 3cm から
  function applyInitial() {
    state.pendingInit = false;
    resetMeasure();
    var input = state.input;
    if (!input) return;
    var v = Math.round(parseFloat(input.value) * 10);
    var last = state.lastByInput[input.id];
    if (last && last.total === v && last.bMm <= maxBmm()) {
      state.chain = last.chain.slice();
      state.bMm = last.bMm;
      return;
    }
    if (isFinite(v) && v >= 1 && v <= maxBmm()) state.bMm = v;
  }

  // ---------- 端末の変化を見張る ----------
  function onViewportChange() {
    if (!state.open) return;
    cancelAnimationFrame(state.raf);
    state.raf = requestAnimationFrame(function () {
      var uncovered = false;
      if (state.phone && (state.pendingStart || state.view === 'cal' || state.view === 'ruler')) {
        // スマホは縦向きだけで使う。横向きの間は覆いを出して止め、校正の判定や測り直しには進まない（測った長さを残す）
        if (orientationKey() === 'l') { showRotate(); return; }
        uncovered = hideRotate();
        if (state.pendingStart) { state.pendingStart = false; startMeasure(); return; }
      }
      if (state.view === 'cal') {
        renderCal();
        if (uncovered) focusEl($(calAlign.hidden ? '[data-lr-action="cal-start"]' : '[data-lr-action="cal-minus"]'));
        return;
      }
      if (state.view !== 'ruler') return;
      var c = currentCal();
      if (!c) {
        endDrag();
        resetMeasure();   // 合わせ直した後に、前の測定値が残らないようにする
        state.pendingInit = true;   // 合わせ直した後は、入力欄の値から置き直す
        showAlert(viewportScaleOk()
          ? '画面の大きさが変わりました。もう一度合わせてください'
          : '画面が拡大されています。2 本指で元の大きさに戻してください');
        showCal();
        return;
      }
      if (state.measureOrient && metrics().orient !== state.measureOrient) {
        // 測っている途中で向きが変わったら、測った長さを捨てて測り直してもらう（その向きの校正値で開き直す）
        endDrag();
        resetMeasure();
        state.pxPerMm = c.pxPerMm;
        showAlert('画面の向きが変わったので、もう一度測ってください');
        showRuler(false);
        return;
      }
      state.pxPerMm = c.pxPerMm;
      layoutRuler();
      if (state.pendingInit) {
        // 開いた直後（最初の描画前）に横向きになっていた：縦で初めて描く時に初期位置と初回の案内を行う
        applyInitial();
        layoutRuler();
        if (!pref.seen[pref.method]) openHelp(pref.method);
      }
      if (uncovered && Math.round(state.bMm) > maxBmm()) {
        // 縦に戻った時に画面が低くなっていると、線が元の位置まで届かない（見えている線の値が入る）
        showAlert('画面の高さが変わったため、線が元の位置まで届きません。長さを確かめてから値を入れてください');
      }
      if (uncovered) focusEl(!help.hidden ? $('[data-lr-method="' + pref.method + '"]') : state.locked ? el.unlock : el.lockBtn);
    });
  }

  // ---------- ドラッグ（つまみの付いた線だけ） ----------
  function yOf(e) { return e.clientY - el.ruler.getBoundingClientRect().top; }
  function onPointerDown(e) {
    if (state.drag || rotateBlocked()) return;
    if (!(e.target.closest && e.target.closest('.lr-knob'))) return;   // 線はつまみを直接つかんだ時だけ動く（紐や手のひらが線に触れても動かない）
    state.drag = { id: e.pointerId, offset: yOf(e) - (yA() + curB() * state.pxPerMm) };
    try { el.b.setPointerCapture(e.pointerId); } catch (err) {}
    e.preventDefault();
  }
  function onPointerMove(e) {
    if (!state.drag || e.pointerId !== state.drag.id) return;
    if (rotateBlocked()) { endDrag(); return; }   // 回転の最中の指の動きで線を動かさない
    var raw = (yOf(e) - state.drag.offset - yA()) / state.pxPerMm;
    state.bMm = Math.max(0, Math.min(maxBmm(), Math.round(raw)));   // 0.1cm（1mm）刻みに吸着
    place();
  }
  function endDrag(e) {
    if (!state.drag) return;
    if (e && e.pointerId !== state.drag.id) return;
    try {
      if (el.b.hasPointerCapture && el.b.hasPointerCapture(state.drag.id)) el.b.releasePointerCapture(state.drag.id);
    } catch (err) {}
    state.drag = null;
  }
  function nudge(dir) { state.bMm = Math.max(0, Math.min(maxBmm(), curB() + dir)); place(); }

  // ---------- 値を入れる ----------
  function apply() {
    var input = state.input;
    if (!input) { close(); return; }
    var total = sum() + curB();
    state.lastByInput[input.id] = { chain: state.chain.slice(), bMm: curB(), total: total };
    input.value = (total / 10).toFixed(1);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    // tryRecalcPreview() はエラー表示を更新しないので、エラーが出ている時だけ出し直す
    try {
      var stepNo = parseInt(state.step, 10);
      var err = document.getElementById('err-' + stepNo);
      if (err && err.classList.contains('show') && typeof validateStep === 'function') validateStep(stepNo);
    } catch (e) {}
    // 結果画面のアンケートに「スマホ定規を使った」と添えるための印（GA4 の送信とは別。gtag が無くても立てる）
    if (typeof window.meterFeedbackCall === 'function') window.meterFeedbackCall('markRuler');
    track('meter_ruler_apply', { step: state.step, method: pref.method, segments: state.chain.length + 1 });
    markFilled(state.opener, input);
    close();
  }
  function markFilled(opener, input) {
    if (!opener) return;
    var label = opener.querySelector('[data-lr-trigger-text]');
    if (label) label.textContent = 'もう一度スマホで測る';
    var note = document.querySelector('[data-lace-ruler-note="' + input.id + '"]');
    if (note) {
      note.textContent = 'スマホで測った値を入れました';
      note.classList.add('is-filled');
    }
  }
  // 手で値を変えたら「スマホで測った値」の表示を元に戻す（元の入力欄と STEP8 の編集欄の両方を見る。リスナーは 1 つだけ）
  function onManualInput(ev) {
    // お客様の手入力と、メーターの − ＋ ボタン（meterStepper の印つき）だけを見る。定規自身の値反映は除く
    if (!(ev.isTrusted || ev.meterStepper) || !ev.target || !ev.target.id) return;
    var id = ev.target.id.indexOf('s8-') === 0 ? ev.target.id.slice(3) : ev.target.id;
    var note = null;
    try {
      var safe = window.CSS && CSS.escape ? CSS.escape(id) : id.replace(/[^A-Za-z0-9_-]/g, '');
      note = document.querySelector('[data-lace-ruler-note="' + safe + '"].is-filled');
    } catch (e) { return; }
    if (!note) return;
    note.textContent = note.getAttribute('data-default-text') || '';
    note.classList.remove('is-filled');
  }

  // ---------- フォーカス ----------
  function focusables(scope) {
    return Array.prototype.filter.call(
      (scope || root).querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
      function (n) { return !n.disabled && n.tabIndex >= 0 && n.offsetParent !== null; }   // tabIndex=-1（選んでいないタブ）は Tab で回らない
    );
  }
  function focusEl(n) {
    if (n) { try { n.focus({ preventScroll: true }); } catch (e) {} }
  }
  function focusFirst(scope) {
    var list = focusables(scope);
    if (list.length) list[0].focus({ preventScroll: true });
  }
  function trapTab(e) {
    var list = focusables(activeScope());
    if (!list.length) { e.preventDefault(); if (rotateShown()) focusEl(el.rotate); return; }   // 覆いの中など、押せる物が無い所からは出さない
    var first = list[0], last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (!root.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
  }
  function activeScope() {
    if (rotateShown()) return el.rotate;
    if (state.view === 'ruler') {
      if (!help.hidden) return help;
    }
    return root;
  }

  // ---------- 背景を止める（inert・スクロール） ----------
  function inertNode(n) {
    if (n === root || n.nodeType !== 1 || n.inert) return;
    var tag = n.tagName;
    if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'LINK' || tag === 'TEMPLATE') return;
    n.inert = true;
    state.inerted.push(n);
  }
  function lockBackground() {
    Array.prototype.forEach.call(document.body.children, inertNode);
    if (typeof MutationObserver === 'function') {
      state.observer = new MutationObserver(function (list) {
        list.forEach(function (rec) { Array.prototype.forEach.call(rec.addedNodes, inertNode); });
      });
      state.observer.observe(document.body, { childList: true });
    }
    state.prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  function unlockBackground() {
    if (state.observer) { state.observer.disconnect(); state.observer = null; }
    state.inerted.forEach(function (n) { n.inert = false; });
    state.inerted = [];
    document.body.style.overflow = state.prevOverflow || '';
    state.prevOverflow = null;
  }

  // ---------- 開く・閉じる ----------
  function onKeyDown(e) {
    if (!state.open) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!state.locked) close();   // ESC 1 回で定規を閉じる（使い方の案内が出ていても同じ）。ロック中は閉じない
      return;
    }
    if (e.key === 'Tab') { trapTab(e); return; }
    if (rotateBlocked()) { e.preventDefault(); return; }   // 横向きの間は、Escape と Tab 以外のキーは使わない（スライダー等の標準操作も止める）
    // 案内のタブは ← → でも切り替える
    var tab = document.activeElement && document.activeElement.getAttribute && document.activeElement.getAttribute('data-lr-method');
    if (tab && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) {
      e.preventDefault();
      showMethod(tab === 'direct' ? 'lace' : 'direct');
      focusEl($('[data-lr-method="' + pref.method + '"]'));
      return;
    }
    if (state.view === 'ruler' && document.activeElement === el.b) {
      if (e.key === 'ArrowUp') { e.preventDefault(); nudge(-1); }
      if (e.key === 'ArrowDown') { e.preventDefault(); nudge(1); }
    }
  }

  function open(opts) {
    if (state.open) return;
    if (typeof window.meterHoldStop === 'function') window.meterHoldStop();   // メーターの − ＋ の長押しを止める
    opts = opts || {};
    var input = document.getElementById(opts.inputId);
    if (!input) return;
    state.open = true;
    state.input = input;
    state.opener = opts.opener || null;
    state.label = opts.label || '';
    state.step = opts.step != null ? String(opts.step) : '';
    state.surface = opts.surface === 'modal' ? 'modal' : 'page';
    state.coarse = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
    state.touchPc = !state.coarse && (navigator.maxTouchPoints || 0) > 0;
    state.phone = state.coarse && Math.min(screen.width, screen.height) < 600;   // スマホ（iPad・PC は横向きでも使える）
    state.pendingStart = false;
    setLocked(false);
    resetMeasure();
    state.pendingInit = true;
    labels.forEach(function (n) { n.textContent = state.label; });
    // ヘッダーの「STEP 04 / 08」はメーター側の表記をそのまま使う（無ければ出さない）
    var stepNo = document.querySelector('#step-' + parseInt(state.step, 10) + ' .step-num');
    el.stepNo.textContent = stepNo ? stepNo.textContent : '';
    el.stepNo.hidden = !stepNo;

    var ac = typeof AbortController === 'function' ? new AbortController() : null;
    state.abort = ac;
    var sig = ac ? { signal: ac.signal } : undefined;
    var sigCap = ac ? { signal: ac.signal, capture: true } : true;
    document.addEventListener('keydown', onKeyDown, sigCap);
    window.addEventListener('resize', onViewportChange, sig);
    window.addEventListener('orientationchange', onViewportChange, sig);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', onViewportChange, sig);
    el.b.addEventListener('pointerdown', onPointerDown, sig);
    el.b.addEventListener('pointermove', onPointerMove, sig);
    el.b.addEventListener('pointerup', endDrag, sig);
    el.b.addEventListener('pointercancel', endDrag, sig);
    el.b.addEventListener('lostpointercapture', endDrag, sig);
    el.unlock.addEventListener('pointerdown', onUnlockPointerDown, sig);
    el.unlock.addEventListener('pointermove', onUnlockPointerMove, sig);
    el.unlock.addEventListener('pointerup', onUnlockPointerEnd, sig);
    // canvas の文字は Web フォントの読み込みを待たずに描かれるので、読み込み後に一度描き直す
    try {
      if (document.fonts && document.fonts.load) {
        // 片方が読めなくても、読めた方の分だけは描き直す（Promise.all だと 1 つの失敗で全部止まる）
        [[RULER_FONT_NUM, '0123456789'], [RULER_FONT_LABEL, '区間 0123456789 継ぎ足し位置（ここに端を合わせる）画面の下 cm から'],
         [RULER_FONT_LABEL_L, '区間 0123456789：cm から（ここに端を合わせる）']].forEach(function (f) {
          document.fonts.load(f[0], f[1]).then(function () { if (state.open) layoutRuler(); }, function () {});
        });
      }
    } catch (e) {}
    el.unlock.addEventListener('pointercancel', onUnlockPointerEnd, sig);
    el.unlock.addEventListener('pointerleave', onUnlockPointerEnd, sig);
    el.unlock.addEventListener('keydown', onUnlockKeyDown, sig);
    document.addEventListener('keyup', onUnlockKeyUp, sigCap);   // フォーカスが移ってから離しても拾う
    el.unlock.addEventListener('blur', cancelHold, sig);
    el.unlock.addEventListener('contextmenu', preventDefault, sig);
    window.addEventListener('blur', cancelHold, sig);
    document.addEventListener('visibilitychange', onHidden, sig);
    // AbortController が無い古い端末向け：close で個別に外す
    state.fallbackRemove = ac ? null : function () {
      document.removeEventListener('keydown', onKeyDown, true);
      window.removeEventListener('resize', onViewportChange);
      window.removeEventListener('orientationchange', onViewportChange);
      if (window.visualViewport) window.visualViewport.removeEventListener('resize', onViewportChange);
      el.b.removeEventListener('pointerdown', onPointerDown);
      el.b.removeEventListener('pointermove', onPointerMove);
      el.b.removeEventListener('pointerup', endDrag);
      el.b.removeEventListener('pointercancel', endDrag);
      el.b.removeEventListener('lostpointercapture', endDrag);
      el.unlock.removeEventListener('pointerdown', onUnlockPointerDown);
      el.unlock.removeEventListener('pointermove', onUnlockPointerMove);
      el.unlock.removeEventListener('pointerup', onUnlockPointerEnd);
      el.unlock.removeEventListener('pointercancel', onUnlockPointerEnd);
      el.unlock.removeEventListener('pointerleave', onUnlockPointerEnd);
      el.unlock.removeEventListener('keydown', onUnlockKeyDown);
      document.removeEventListener('keyup', onUnlockKeyUp, true);
      el.unlock.removeEventListener('blur', cancelHold);
      el.unlock.removeEventListener('contextmenu', preventDefault);
      window.removeEventListener('blur', cancelHold);
      document.removeEventListener('visibilitychange', onHidden);
    };

    root.hidden = false;
    lockBackground();
    track('meter_ruler_open', { step: state.step, method: pref.method });

    if (!state.coarse) {
      el.useHere.hidden = !state.touchPc;
      showView('qr');
      track('meter_ruler_qr', {});
      focusFirst(views.qr);
      return;
    }
    if (state.phone && orientationKey() === 'l') {
      // スマホを横向きで開いた：覆いだけ出して、縦になってから画面合わせ・定規を始める
      state.pendingStart = true;
      showView(null);
      showRotate();
      return;
    }
    startMeasure();
  }

  function close() {
    if (!state.open) return;
    endDrag();
    if (state.abort) state.abort.abort();
    if (state.fallbackRemove) state.fallbackRemove();
    state.abort = null;
    state.fallbackRemove = null;
    cancelAnimationFrame(state.raf);
    state.open = false;
    state.pendingStart = false;
    setLocked(false);
    hideRotate();
    showView(null);
    root.hidden = true;
    el.alert.hidden = true;
    unlockBackground();
    var opener = state.opener;
    state.input = null;
    state.opener = null;
    if (opener && document.contains(opener)) {
      try { opener.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  // ---------- クリック（イベント委譲） ----------
  root.addEventListener('click', function (e) {
    var t = e.target.closest('button');
    if (!t || !root.contains(t)) return;
    if (state.locked) return;   // ロック中はクリックを全部無視（解除はクリックではなく長押し）
    if (rotateBlocked()) return;   // 回転の最中に触れたボタンは反応させない
    var ref = t.getAttribute('data-lr-ref');
    if (ref) { state.calRef = ref === 'coin' ? 'coin' : 'card'; renderRefChoice(); return; }
    var method = t.getAttribute('data-lr-method');
    if (method) { showMethod(method); return; }
    switch (t.getAttribute('data-lr-action')) {
      case 'close': close(); break;
      case 'lock': lockRuler(); break;
      case 'cal-start': startAlign(); break;
      case 'cal-back': showCal(); break;
      case 'cal-minus': state.calPpm = Math.max(4.5, +(state.calPpm - 0.01).toFixed(3)); renderCal(); break;
      case 'cal-plus': state.calPpm = Math.min(8.5, +(state.calPpm + 0.01).toFixed(3)); renderCal(); break;
      case 'cal-save': saveCal(); break;
      case 'recal': endDrag(); resetMeasure(); state.pendingInit = true; showCal(); break;
      case 'help': openHelp(pref.method); break;
      case 'help-close': closeHelp(); break;
      case 'up': nudge(-1); break;
      case 'down': nudge(1); break;
      case 'chain':
        if (curB() < 1) { showAlert('つまみの付いた線を動かして長さを測ってから継ぎ足してください'); break; }
        state.chain.push(curB());
        state.bMm = 5;
        layoutRuler();
        showAlert('区間 ' + (state.chain.length + 1) + '：点線（区間 ' + state.chain.length + ' 継ぎ足し位置）の所を 0 の線に合わせ直してください');
        break;
      case 'undo':
        if (state.chain.length) { state.bMm = state.chain.pop(); hideChainAlert(); layoutRuler(); }
        break;
      case 'reset': resetMeasure(); hideChainAlert(); layoutRuler(); break;
      case 'apply': apply(); break;
      case 'show-qr': showView('qr'); el.useHere.hidden = false; track('meter_ruler_qr', {}); focusFirst(views.qr); break;
      case 'use-here': startMeasure(); break;
    }
  });
  el.calRange.addEventListener('input', function () {
    if (rotateBlocked()) { el.calRange.value = String(state.calPpm); return; }
    var v = parseFloat(el.calRange.value);
    if (v > 0) { state.calPpm = v; renderCal(); }
  });

  // ---------- メーター側の起動ボタン ----------
  function onTriggerClick(e) {
    var t = e.target.closest('[data-lace-ruler-input]');
    if (!t) return;
    e.preventDefault();
    open({
      inputId: t.getAttribute('data-lace-ruler-input'),
      label: t.getAttribute('data-lace-ruler-label') || '',
      step: t.getAttribute('data-lace-ruler-step') || '',
      surface: t.closest('#shoelace-meter-modal') ? 'modal' : 'page',
      opener: t
    });
  }

  // ---------- 起動条件の確認 → ボタンを出す ----------
  function cssReady() {
    try { return getComputedStyle(root).getPropertyValue('--lace-ruler-ready').trim() === '1'; }
    catch (e) { return false; }
  }
  function reveal() {
    document.querySelectorAll('[data-lace-ruler-show]').forEach(function (n) { n.hidden = false; });
  }
  function init() {
    if (root.parentNode !== document.body) document.body.appendChild(root);   // 必ず body 直下に置く（inert とクリップ対策）
    document.addEventListener('click', onTriggerClick);
    document.addEventListener('input', onManualInput, true);
    window.LaceRuler = {
      open: open,
      close: close,
      isOpen: function () { return state.open; }
    };
    if (cssReady()) { reveal(); return; }
    // CSS の読み込みが遅れている場合に備え、load 後にもう一度だけ確認する
    window.addEventListener('load', function () { if (cssReady()) reveal(); }, { once: true });
  }

  try { init(); } catch (e) { /* 初期化に失敗したらボタンは hidden のまま＝今までどおりのメーター */ }
})();
